<ng-container>
  <div class="formControl mt">
    <pr-input-radio
      formControlName="investmentDuration"
      direction="column"
      [isDefault]="false"
      columns="2"
      [options]="options"
    >
    </pr-input-radio>
  </div>
</ng-container>
